module.exports = __webpack_public_path__ + "static/media/stop.65a5835f.jpg";